exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--head__3LBSm{border-bottom-width:1px;border-style:solid}.styles--title__fWc9I{font-size:19px;line-height:25px;font-weight:600}.styles--upload__3nogV{border-bottom-width:1px;border-style:solid}.styles--dndUpload__24F35{display:none;background:rgba(0, 0, 0, .8);position:fixed;top:0;right:0;bottom:0;left:0;z-index:2000}.styles--dndUploadWrap__JHXpy{color:#ffffff;font-size:32px;line-height:40px;position:absolute;top:20px;right:20px;bottom:20px;left:20px}\n", ""]);

// exports
exports.locals = {
	"head": "styles--head__3LBSm",
	"title": "styles--title__fWc9I",
	"upload": "styles--upload__3nogV",
	"dndUpload": "styles--dndUpload__24F35",
	"dndUploadWrap": "styles--dndUploadWrap__JHXpy"
};